module.exports = __webpack_public_path__ + "static/media/GALLERY.3bb02248.png";